// api.js
import axios from 'axios';

const baseURL = process.env.VUE_APP_EASY_API_BASE_URL


// Create an Axios instance
const api = axios.create({
  baseURL: baseURL, // Set your API base URL
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add access token to headers
api.interceptors.request.use(
  config => {
    const accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

// Response interceptor to handle token expiration
api.interceptors.response.use(
  response => response, // If response is successful, just return it
  async error => {
    const originalRequest = error.config;

    // Check if error is due to token expiration (e.g., 401 Unauthorized)
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; // Mark the request as retried

      // Attempt to refresh the access token using the refresh token
      const refreshToken = localStorage.getItem('refreshToken');

      try {
        const response = await axios.post('/token/refresh/', {
            refresh: refreshToken
        });

        const newAccessToken = response.data.access_token;

        // Store the new access token in localStorage
        localStorage.setItem('accessToken', newAccessToken);

        // Update the Authorization header with the new access token
        api.defaults.headers['Authorization'] = `Bearer ${newAccessToken}`;
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

        // Retry the original request with the new access token
        return api(originalRequest);
      } catch (refreshError) {
        // If refreshing the token fails, log the user out or redirect to login
        console.log('Refresh token failed. Logging out.');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';

        return Promise.reject(refreshError);
      }
    }

    // If the error is not 401 or token refresh fails, reject the promise
    return Promise.reject(error);
  }
);

export default api;
